var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1724667957306,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5231,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M832 316v120c0-16.569 13.431-30 30-30 16.569 0 30 13.431 30 30v74.706c0 165.22-127.055 314.796-381.165 448.732C258.278 825.502 132 675.925 132 510.706V198.012L512 64l380 134.012V316c0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30z m0 194.866V247.563L512 134.72 192 247.563v263.303c0 139.122 106.34 265.073 319.019 377.853C725.006 775.939 832 649.989 832 510.866zM476.42 617.595c-19.255 9.456-44.377 14.184-75.366 14.184-39.877 0-71.521-11.934-94.934-35.803C282.706 572.107 271 540.292 271 500.53c0-41.813 13.074-76.02 39.221-102.624C336.37 371.3 370.121 358 411.48 358c25.862 0 47.51 3.361 64.94 10.083V422.6c-17.887-10.482-38.166-15.723-60.839-15.723-25.863 0-46.541 8.26-62.036 24.78-15.495 16.52-23.242 38.11-23.242 64.77 0 25.977 7.348 46.884 22.046 62.72 14.697 15.837 34.578 23.755 59.643 23.755 23.584 0 45.06-5.696 64.429-17.09v51.783z m276.514 9.57H691.41l-19.824-60.669H575.37l-19.482 60.669h-61.182l96.9-264.722h66.308l95.02 264.722z m-94.678-104.248l-30.078-91.772c-1.937-5.811-3.304-13.501-4.102-23.072h-1.538c-0.684 7.748-2.222 15.21-4.614 22.388l-30.25 92.456h70.582z",
    fill: "#2aa707",
    "p-id": 5232
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/ca.a2d7fcfe.svg";
export { ForwardRef as ReactComponent };